'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { Icon } from '@eliadmin/core/src/components/nt/ui/icon';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** The mobile magnifier opens the same shared search as the desktop trigger. */
export function SearchSheet() {
  const { t } = useTranslations();

  return (
    <SearchDrawer
      trigger={
        <button
          type="button"
          aria-label={t('text1')}
          className="-mr-2 flex size-10 items-center justify-center rounded-xl text-[#0D110D] transition-colors hover:bg-[#F5F6F3] focus-visible:shadow-focus focus-visible:outline-none"
        >
          <Icon name="magnifying-glass" size={24} />
        </button>
      }
    />
  );
}
